import React, { useState, useEffect } from 'react';
import { FiX, FiImage, FiCheck, FiUpload, FiLoader } from 'react-icons/fi';
import api, { getImageUrl } from '../services/api';
import './ImagePickerModal.css';

const ImagePickerModal = ({ isOpen, onClose, onSelect, currentImage }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(currentImage || null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      fetchImages();
      setSelectedImage(currentImage || null);
    }
  }, [isOpen, currentImage]);

  const fetchImages = async () => {
    try {
      setLoading(true);
      const response = await api.get('/upload/gallery');
      setImages(response.data);
      setError('');
    } catch (err) {
      setError('Resimler yüklenirken hata oluştu');
      console.error('Error fetching images:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);
    formData.append('title', file.name);
    formData.append('category', 'gallery');

    try {
      setUploading(true);
      await api.post('/upload/gallery', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      await fetchImages();
      setError('');
    } catch (err) {
      setError('Resim yüklenirken hata oluştu');
      console.error('Error uploading:', err);
    } finally {
      setUploading(false);
    }
  };

  const handleSelect = () => {
    if (selectedImage) {
      onSelect(selectedImage);
      onClose();
    }
  };

  const handleClear = () => {
    onSelect('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="image-picker-overlay" onClick={onClose}>
      <div className="image-picker-modal" onClick={e => e.stopPropagation()}>
        <div className="image-picker-header">
          <h3><FiImage /> Resim Seç</h3>
          <button className="close-btn" onClick={onClose}>
            <FiX />
          </button>
        </div>

        <div className="image-picker-body">
          {error && <div className="image-picker-error">{error}</div>}
          
          <div className="image-picker-upload">
            <label className="upload-btn">
              {uploading ? (
                <>
                  <FiLoader className="spin" />
                  <span>Yükleniyor...</span>
                </>
              ) : (
                <>
                  <FiUpload />
                  <span>Yeni Resim Yükle</span>
                </>
              )}
              <input
                type="file"
                accept="image/*"
                onChange={handleUpload}
                disabled={uploading}
                hidden
              />
            </label>
          </div>

          {loading ? (
            <div className="image-picker-loading">
              <FiLoader className="spin" />
              <span>Resimler yükleniyor...</span>
            </div>
          ) : images.length === 0 ? (
            <div className="image-picker-empty">
              <FiImage />
              <p>Henüz resim yüklenmemiş</p>
            </div>
          ) : (
            <div className="image-picker-grid">
              {images.map((image) => (
                <div
                  key={image._id}
                  className={`image-picker-item ${selectedImage === image.imageUrl ? 'selected' : ''}`}
                  onClick={() => setSelectedImage(image.imageUrl)}
                >
                  <img src={getImageUrl(image.imageUrl)} alt={image.title || 'Gallery'} />
                  {selectedImage === image.imageUrl && (
                    <div className="image-selected-badge">
                      <FiCheck />
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="image-picker-footer">
          <button className="btn btn-secondary" onClick={handleClear}>
            Resmi Kaldır
          </button>
          <div className="footer-actions">
            <button className="btn btn-outline" onClick={onClose}>
              İptal
            </button>
            <button 
              className="btn btn-primary" 
              onClick={handleSelect}
              disabled={!selectedImage}
            >
              <FiCheck /> Seç
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImagePickerModal;
